__webpack_require__.p = "https://ca.knowledgesearchadmin.thomsonreuters.com/";